const basePath = '/api-management/1.0/eulas/';

export const apiEulasDataProvider = context => {
    return {
        getOne: async ({ id }) => {
            //const url = `${context.apiUrl}${basePath}('${id}')`;
            const url = `${context.apiUrl}${basePath}/${id}`;

            const {
                json: { ...data },
            } = await context.fetchJson(url, { credentials: 'include' });

            return {
                data: { id, ...data },
            };
        },
    };
};
